import { css } from '@microsoft/fast-element';

export const ProjectCardStyles = css`
  .project-card {
    padding: 2px;
    border-radius: 6px;
    background-color: rgb(135 155 166 / 7%);
    box-sizing: border-box;
    display: flex;
    gap: 11px;
  }

  .project-card:hover {
    background-color: rgb(45 47 51 / 100%);
  }

  .content {
    width: 100%;
    padding: 8px;
  }

  .project-header-container {
    display: flex;
    justify-content: space-between;
  }

  .project-name {
    color: var(--white-rgb);
    font-size: 14px;
    max-width: 75%;
    margin: 0;
  }

  .resume-setup {
    color: var(--primary-color);
    font-size: 12px;
    height: 24px;
    margin: 0;
  }

  .resume-setup:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .project-company-name {
    color: #ccc;
    margin: 0;
    font-size: 12px;
    height: 24px;
  }

  .project-info-container {
    display: flex;
    justify-content: space-between;
  }

  .info-section {
    display: flex;
    gap: 24px;
  }

  .project-info-title {
    color: var(--font-color-1);
    margin: 0;
    font-size: 10px;
    font-weight: bold;
    height: 18px;
  }

  .project-info-value {
    color: #ccc;
    margin: 0;
    font-size: 12px;
    height: 18px;
    white-space: nowrap;
  }

  .delete-section {
    display: flex;
    align-items: end;
  }

  .delete-icon:hover {
    cursor: pointer;
  }
`;
